const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/CancelOtherSubscriptionModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CancelOtherSubscriptionModal",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,

			otherActiveYearlyStudents: PT.array.isRequired,
			onClose: PT.func,
		},

		cancelSubscription: function(studentID) {
			this.onClose();
			this.props.dispatch({
				type: AT.FINISH_SUBSCRIPTION_CANCEL_REQUEST,
				studentID,
			});
		},

		onClose: function() {
			if (this.props.onClose) {
				this.props.onClose();
			}
		},

		render: function() {
			const {otherActiveYearlyStudents} = this.props;
			const buttons = otherActiveYearlyStudents.map((s, i) => {
				return (
					<div
						className={styles.redButton}
						key={"button" + i}
						onClick={() => this.cancelSubscription(s.userID)}
					>
						Cancel
						<br />
						{s.displayName}
					</div>
				);
			});
			const keepAllButton = (
				<div
					className={styles.button}
					key={"button-keep-all"}
					onClick={this.onClose}
				>
					Keep All Subscriptions
				</div>
			);
			buttons.push(keepAllButton);

			const hasMultipleSubscriptionsToCancel =
				otherActiveYearlyStudents.length > 1;
			const messageCopy = CopyTable.getCancelOtherSubscriptionFirstCopy(
				styles,
				hasMultipleSubscriptionsToCancel
			);

			return (
				<OfficeModal
					onClose={this.onClose}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					modalClass={styles.main}
				>
					<div className={styles.container}>
						<div className={styles.message}>{messageCopy}</div>
						<div className={styles.buttons}>{buttons}</div>
					</div>
				</OfficeModal>
			);
		},
	})
);
